import { Button, Form, Modal, message } from "antd";
import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import ModalHeaderText from "../../../common/ModalHeaders/ModalHeaderText";
import useForm from "../../Common/hooks/useForm";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, notification } from "antd";
import TextInput from "../../Common/UITextInput/TextInput";
import "./PartnerMenu.css";
import { saveThresholdChangeDetails } from "../../../redux/saveChangeThreshold/action";
import { getThresholdChangeDetails } from "../../../redux/ChangeThreshold/action";
import useSession from "../../CustomLogout/useSession";

const ChangeThreshold = ({
  setPartnerRefresh,
  partnerRefresh,
  drawerOpen,
  setDrawerOpen,
  ...props
}) => {
  const handleSessionExpired = useSession();

  const { state, onChangeTextHandler, setState } = useForm();
  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const [saveLoading, setSaveLoading] = useState(false);
  const [isModalChange, setIsModalChange] = useState(false);
  const [threshold, setThreshold] = useState("");
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setIsModalChange(true);
    setDrawerOpen(true);
  };

  const handleCancel = () => {
    setIsModalChange(false);
    setDrawerOpen(false);
    form.resetFields();
  };

  useEffect(() => {
    setLoading(true);
    if (drawerOpen) {
      thresholdChangeDetails();
    }
  }, [drawerOpen]);

  const thresholdChangeDetails = () => {
    props
      .getThresholdChangeDetails({
        access_token: props.access_token,
        partnerFirmId: props.row?.original?.partnerFirmId,
      })
      .then((res) => {
        setLoading(false);
        if (res?.status === 200) {
          setThreshold(res?.data?.leadsThreshold);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            setLoading(false);

            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const handleChangeThreshold = () => {
    setSaveLoading(true);
    const dataChange = {
      leadTresholdAllowedBeforeRegistration:
        state?.leadTresholdAllowedBeforeRegistration,
    };

    props
      .saveThresholdChangeDetails({
        values: dataChange,
        access_token: props.access_token,
        partnerFirmId: props.row?.original?.partnerFirmId,
      })
      .then((res) => {
        setSaveLoading(false);
        if (res && res.status === 200) {
          message.success("Saved");
          handleCancel();
          setIsModalChange(false);
          setPartnerRefresh(true);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            setLoading(false);

            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((e) => {
        setSaveLoading(false);
      });
  };

  return (
    <div>
      {/* <p
        style={{ cursor: "pointer", color: "#00b1b1" }}
        onClick={() => {
          showModal();
          props.hide && props.hide();
        }}
      >
        Change Threshold
      </p> */}

      <Modal
        open={drawerOpen}
        closable={false}
        className="modal-container"
        centered
        footer={null}
      >
        {" "}
        <Form
          autoComplete="off"
          name="changeRM"
          form={form}
          onFinish={handleChangeThreshold}
        >
          <Row>
            <Col lg={12} xs={12} md={12} sm={12}>
              <Col md={12} className="headre-login">
                <ModalHeaderText LoginHeading="Change Threshold" />
              </Col>
            </Col>
          </Row>
          <Row className="mt-4">
            {/* <Col md={6}>
              <p className="change-rm-text">The Current Threshold for</p>
              <p>Saleleader Pvt Ltd is.</p>
              <p className="color-blue">
                {" "}
                {">"} {loading ? "Loading..." : threshold}
              </p>
            </Col> */}
            <Col md={12} className="changeThreshold-se Mob-sec-thre">
              <FormItem
                name="leadTresholdAllowedBeforeRegistration"
                label="Change the Threshold"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "Please Enter Threshold",
                  },
                ]}
              >
                <TextInput
                  type="number"
                  name="leadTresholdAllowedBeforeRegistration"
                  onChange={onChangeTextHandler}
                />
              </FormItem>
            </Col>
          </Row>{" "}
          <Row className="mt-4">
            <Col md={12} className="d-flex justify-content-end">
              {saveLoading && (
                <div className="pr-4 spanner">
                  <Spin
                    size="large"
                    className="pr-4"
                    indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                  ></Spin>
                </div>
              )}
              <Button
                className="mr-3"
                htmlType="button"
                type="default"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
              <Button className="" htmlType="submit" type="primary">
                CONFIRM
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    data: state.thresholdData,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getThresholdChangeDetails: (data) =>
      dispatch(getThresholdChangeDetails(data)),
    saveThresholdChangeDetails: (data) =>
      dispatch(saveThresholdChangeDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeThreshold);
